import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'invites'

export const schema = new schemas.Entity(
  collection,
  {},
  { idAttribute: 'emailAddress' }
)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { id, admin, ...body }: { id: string; admin: boolean }) =>
    admin
      ? callApi(`${ADMIN_API_BASE}/organizations/${id}/invitations`, schema, {
          method: 'POST',
          body,
        })
      : callApi(`${apiBase}/users`, schema, { method: 'POST', body })

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id, admin }: { id: string; admin: string }, emailAddress: string) =>
    admin
      ? callApi(
          `${ADMIN_API_BASE}/organizations/${id}/invitations/${emailAddress}`,
          schema,
          {
            method: 'DELETE',
          }
        )
      : callApi(`${apiBase}/invitations/${emailAddress}`, schema, {
          method: 'DELETE',
        })
